import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { ListItem, Box, Button, CircularProgress } from '@material-ui/core';
import SelectBox from '../CustomizedUIs/CustomSelectBox';
import { useMediaQuery } from '@material-ui/core';
import IconTitle from '../users/iconTitle';
import Typography from '@material-ui/core/Typography';
import { useTranslate, useDataProvider } from 'react-admin';
import CustomTextField from '../CustomizedUIs/CustomTextFiled'
import CustomPoper from '../CustomizedUIs/CustomPoper';
import GreenSwitch from '../CustomizedUIs/GreenSwitch'
import { Link } from "react-router-dom";
import { red, pink } from '@material-ui/core/colors';
import TextButton from '../CustomizedUIs/TextButton';
const bgColorError = pink['50'];
const textColorError = red['700'];

const useStyles = makeStyles(theme => ({
    TitleCreate: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },
    textExpand: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#4f5064',
        padding: '5px 8px 5px 8px'
    },
    TexTSelect: {
        fontFamily: 'UniviaPro',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.85,
        letterSpacing: '0.13px',
        color: '#4f5064',
    },
    boxBoder: {
        borderBottom: '1px solid',
        borderRight: '1px solid',
        borderBottomColor: '#f3f7fa',
        borderRightColor: '#f3f7fa',
    },

    btnCreate: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '11px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: '0.44px',
        color: '#ffffff',
        padding: '5px'
    },
}))


export const CreateInfoChannel = (props) => {
    const translate = useTranslate();
    const dataProvider = useDataProvider()
    const isDesktop = useMediaQuery(theme => theme.breakpoints.up('md'));
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [openPoper, setOpenPopper] = React.useState(false);
    const [inheritFrom, setInheritFrom] = useState(false);
    const [openInherit, setOpenInherit] = useState(false);
    const [inherit, setInherit] = useState({ name: '' });
    const [loading, setLoading] = useState(false);
    const [infoChannels, setInfoChannels] = useState([])
    const [error, setError] = useState('')

    const onChangeInheritFrom = () => {
        setInheritFrom(!inheritFrom)

    }
    const [textValue, setTextValue] = React.useState({
        channelName: '',

    });
    const [validate, setValidate] = React.useState({
        channelName: {
            isError: true,
            message: ''
        },

    });

    const textOnChange = prop => (e) => {
        setTextValue({
            ...textValue, [prop]: e.target.value
        })
        setValidate({
            ...validate, [prop]: e.target.value.length === 0 ? {
                isError: true, message: 'required'
            } : {
                    isError: false, message: ''
                }
        })
    }


    const handleClosePoper = () => {
        setOpenPopper(false);
    };

    const handleClickOpenPoper = (event) => {
        setAnchorEl(event.currentTarget);
        setOpenPopper(true);
    };

    const handleClickOpenInherit = () => {
        setOpenInherit(!openInherit)
    }

    const onChangeInherit = (value) => {
        setInherit(value)
        setOpenInherit(false)
    }

    const onSave = () => {
        setLoading(true)
        var body = { name: textValue.channelName.trim() }
        if (inheritFrom && inherit.name !== '')
            body.inheritfrom = inherit.id
        dataProvider('CREATE', "infochannels", {
            data: body
        })
            .then(({ data }) => {

                props.history.push('/InfoChannel/' + data.id)
                setLoading(false)
            })
            .catch(error => {
                if (error.message === 'info channel name is exist!')
                    setError('Name exist')
                else
                    setError('Create failed')
                setLoading(false)
            })

    }

    React.useEffect(() => {

        dataProvider('GET_LIST', "infochannels", {
            filter: {
            },
            pagination: {},
            sort: { field: 'name', order: 'ASC' },

        })
            .then(({ data }) => {
                setInfoChannels(data);
                data && data.length > 0 &&
                    setInherit(data[0])

            })
            .catch(error => {

            })

    }, [])
    if (!inherit && infoChannels.length > 0) return null
    return (
        <Box width='100%' >
            <Box width={!isDesktop ? '95%' : '80%'} m='auto'>
                <IconTitle
                    TitleBack={translate(`pos.infochannel.back`)}
                    TitleName=''
                    pathName='/InfoChannel'
                />
            </Box>
            <Box display='flex' width='100%' justifyContent='center'>
                <Box my={2} style={{ width: '500px' }} >

                    <Typography className={classes.TitleCreate}>{translate(`pos.infochannel.title`)}</Typography>
                    {
                        error != "" && (
                            <Box borderRadius='6px' my={1} width={500} bgcolor={bgColorError} py={1}>
                                <Typography variant='subtitle2' style={{ color: textColorError, margin: '1em' }}>{error}</Typography>
                            </Box>
                        )
                    }
                    <Box mt={3}>
                        <CustomTextField
                            required
                            onBlur={textOnChange('channelName')}
                            id="filled-basic"
                            label={translate(`pos.infochannel.name`)}
                            value={textValue.channelName}
                            error={validate.channelName.message != "" && validate.channelName.isError}
                            helperText={validate.channelName.message}
                            onChange={textOnChange('channelName')}
                            style={{ width: 500 }}
                            endDom={
                                <CustomPoper
                                    open={openPoper}
                                    anchorEl={anchorEl}
                                    handleClick={handleClickOpenPoper}
                                    handleClose={handleClosePoper}
                                    title={translate(`pos.infochannel.TitleChannelName`)}
                                    content={translate(`pos.infochannel.ConstentChannelName`)}
                                    icon={<b>?</b>}
                                />
                            } />
                    </Box>
                    <Box mt={3}>
                        <Box width={145} height={30} borderRadius='4px' justifyContent='center' px={1} display="flex" bgcolor='#ffffff' alignItems='center'>
                            <Typography className={classes.textExpand} >
                                {translate(`pos.infochannel.inheritFrom`).toUpperCase()}
                            </Typography>
                            <GreenSwitch
                                disabled={openInherit}
                                size='small'
                                checked={inheritFrom}
                                onChange={onChangeInheritFrom}>
                            </GreenSwitch>
                        </Box>
                    </Box>

                    {
                        inheritFrom && (
                            <Box pt={1} pb={0} mt={1} >
                                <SelectBox
                                    disabled={!inheritFrom}
                                    label={translate(`pos.infochannel.inheritFrom`)}
                                    value={inherit.name===""?"":<Typography className={classes.TexTSelect} >{inherit.name}</Typography>}
                                    open={openInherit}
                                    handleClick={handleClickOpenInherit}
                                >
                                    <Box className={classes.boxBoder} >
                                        {
                                            infoChannels.map(value => (
                                                <ListItem key={value.id} style={{ padding: '8px' }} button onClick={() => onChangeInherit(value)}>
                                                    <Typography className={classes.TexTSelect} >{value.name}</Typography>
                                                </ListItem>
                                            ))
                                        }

                                    </Box>
                                </SelectBox>
                            </Box>
                        )
                    }

                    <Box display='flex' justifyContent='flex-end'>
                        <Box display='flex' alignItems='flex-end' mt={3}  >
                            <TextButton style={{ marginRight: '30px' }} component={Link} to={{ pathname: "/InfoChannel" }}/>
                               
                            <Button variant="contained" color='primary' size='large'
                                disabled={validate.channelName.isError || loading}
                                onClick={onSave}
                            >
                                {loading ? (
                                    <CircularProgress
                                        size={20}
                                        thickness={2}
                                        color='inherit'
                                    />
                                ) : <Typography className={classes.btnCreate}>{translate(`pos.infochannel.createInheritFrom`)}</Typography>}
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Box>
    )

}
export default CreateInfoChannel